// extracted by mini-css-extract-plugin
module.exports = {"container":"OptIn_container__2aiRz","illustration":"OptIn_illustration__23EE3","message":"OptIn_message__UF9K-","allowButton":"OptIn_allowButton__1alGv","link":"OptIn_link__2_B9p"};